import { render } from "./gang-call-notify.vue?vue&type=template&id=45814288"
import script from "./gang-call-notify.vue?vue&type=script&lang=js"
export * from "./gang-call-notify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__